/* global attachEvent */
// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

const filesToUpload = [];
const fileUploadInput = document.querySelectorAll('.upload-box__input');

if (fileUploadInput.length > 0) {
  let nextFileID = 1;
  const uploadBox = document.getElementById('job_upload');

  const fileRemoved = new Event('fileRemoved');

  const fileUploader = (evt, files) => {
    const parentElem = evt.target.closest('.upload-box');
    const selectedList = parentElem.querySelector('.upload-box__list-text-wrapper');
    const selectedListParent = parentElem.querySelector('.upload-box__list');

    Array.from(files).forEach((file) => {
      filesToUpload.push({ id: nextFileID, file });
      nextFileID += 1;
    });

    const fileName = filesToUpload
      .map(
        (file) =>
          `<li><div class="upload-box__list-icon : d-flex-cc"><i class="icon : icon-file-text"></i></div><div class="upload-box__list-middle"><div class='upload-box__list-text'>${
            file.file.name
          }</div><div class='upload-box__list-size'>${(file.file.size / 1024).toFixed(2)} KB</div></div><button id=${
            file.id
          } type='button' class='upload-box__list-remove'> <i class="icon : icon-bin"></i> </button></li>`,
      )
      .join('');

    selectedListParent.classList.remove('hide');
    selectedList.innerHTML = `<ul>${fileName}</ul>`;
  };

  fileUploadInput.forEach((el) => {
    el.addEventListener('change', (evt) => {
      fileUploader(evt, evt.target.files);
    });

    // File drop
    const parentElem = el.closest('.upload-box');
    const holder = parentElem.querySelector('.upload-box__inner');
    if (holder) {
      holder.ondragover = () => {
        parentElem.classList.add('is-hovered');
      };
      holder.ondragend = () => {
        parentElem.classList.remove('is-hovered');
      };
      holder.ondrop = (e) => {
        parentElem.classList.remove('is-hovered');
        el.files = e.dataTransfer.files;
        fileUploader(e, e.dataTransfer.files);
        e.preventDefault();
      };
    }
  });

  // *******************************************************************************
  // Remove uploaded files
  // *******************************************************************************

  attachEvent('.upload-box__list-remove', 'click', (el) => {
    const removeParentElem = el.target.closest('li');

    Array.from(filesToUpload).forEach((file, i) => {
      if (file.id === Number(el.target.id)) {
        filesToUpload.splice(i, 1);
        uploadBox.value = null;
      }
    });

    uploadBox.dispatchEvent(fileRemoved);
    removeParentElem.remove();
  });
}
